module.exports = __webpack_public_path__ + "img/refresh_actualizar.f868077f.svg";